import React, { type ReactNode } from 'react';

import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';

import { LoadingContent } from '../loading-content';

export const Loading = ({
	loadingText,
	title,
}: {
	loadingText?: ReactNode;
	title: ReactNode;
}): React.JSX.Element => (
	<>
		<ModalHeader hasCloseButton>{title ? <ModalTitle>{title}</ModalTitle> : null}</ModalHeader>
		<ModalBody>
			<LoadingContent
				loadingText={loadingText ?? 'Loading dialog content...'}
				spinnerSize="large"
			/>
		</ModalBody>
		<ModalFooter />
	</>
);
